import script from "./UnsavedChangesDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UnsavedChangesDialog.vue?vue&type=script&setup=true&lang=js"

import "./UnsavedChangesDialog.vue?vue&type=style&index=0&id=feeb6264&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-feeb6264"]])

export default __exports__